<template>
  <div class="InteiroTeor">
    <div v-if="false"
         class="row align-items-end justify-content-between mt-2">
      <div class="col-6">
        <label for="modelo-inteiro-teor"
               class="label">Modelo de inteiro teor</label>
        <select id="modelo-inteiro-teor"
                v-model="modeloSelected"
                name="modelo-inteiro-teor"
                class="form-control form-control-sm">
          <option v-if="!modelos.length"
                  disabled>
            Sem modelos cadastrados
          </option>
          <option :value="null"
                  disabled>
            Selecione
          </option>
          <option v-for="(modelo, index) in modelos"
                  :key="index"
                  :value="modelo">
            {{ modelo.titulo }}
          </option>
        </select>
      </div>
      <div class="col-3 d-flex justify-content-end">
        <button class="btn btn-sm btn-secondary"
                :disabled="!modeloSelected"
                @click="changeText()">
          Gerar texto de inteiro teor
        </button>
      </div>
    </div>
    <div class="row align-items-end justify-content-between mt-2">
      <div class="col-12">
        <label for=""
               class="label">Texto da certidão</label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <!-- <textarea id="descricao"
                  v-model="textoImpressao"
                  v-validate="{'required': verifyText()}"
                  name="descricao"
                  cols="30"
                  rows="20"
                  class="form form-control form-control-sm"
                  :class="{'is-invalid': errors.has('descricao')}" /> -->
        <div id="textoImpressao"
             name="textoImpressao"
             class="editorTextoInteiroTeor text-justify"
             contenteditable="true"
             @blur="getHtml('textoImpressao')"
             v-html="textoImpressao" />
        <small class="invalid-feedback">{{ errors.first('textoImpressao') }}</small>
      </div>
    </div>
    <div v-if="verifyText()"
         class="row justify-content-center align-items-center mt-2">
      <p class="p-0 m-0 mr-2">
        Parece que você realizou algumas alterações no texto. Gostaria de gerar um novo modelo a partir dessas alterações?
      </p>
      <button class="btn btn-sm btn-outline-secondary"
              @click="salvarModelo()">
        Criar novo modelo
      </button>
    </div>
    <div id="assinatura_certidao"
         class="mt-4">
      <sub-header-grey class="row mt-1 mb-1">
        <div class="d-flex justify-content-between pb-1 pl-2">
          Assinatura da Certidão
        </div>
      </sub-header-grey>

      <div class="row">
        <div class="col-5">
          <label class="impressao--label"
                 for="">
            Assinante da certidão:
          </label>
          <b-form-select v-model="impressao.assinante"
                         v-validate="'required'"
                         class="mb-3"
                         :class="{'is-invalid':errors.has('assinante')}"
                         name="assinante"
                         size="sm"
                         @change="changeImpressao()">
            <template v-slot:first>
              <option :value="null"
                      disabled>
                -- Selecione uma opção --
              </option>
            </template>
            <option v-for="(assinante,index) in assinantes"
                    :key="'assinante_'+index"
                    :value="assinante">
              {{ assinante.nome }}
            </option>
          </b-form-select>
        </div>
      </div>
    </div>
    <hr>
    <div class="row justify-content-end">
      <button class="btn btn-sm btn-light active px-3 mr-2"
              @click="voltar()">
        Voltar
      </button>
      <b-dropdown size="sm"
                  right
                  split
                  text="Pré Visualizar"
                  :disabled="!textoImpressao"
                  @click="visualizar()">
        <b-dropdown-item @click="visualizar()">
          Pré Visualizar
        </b-dropdown-item>
        <b-dropdown-item @click="imprimir()">
          Imprimir
        </b-dropdown-item>
        <b-dropdown-item 
          @click="gerarCertidao(impressao)">
          Gerar Certidão Eletrônica
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <modal-certidao-eletronica :data="{ urlPDFCertidao, certidaoEletronicaId }"
                               :zoom="zoom"
                               :prop-file-preview="filePreview"
                               @onAssinar="assinarCertidaoEletronica" />
  </div>
</template>

<script>
  // helpers
  import livro from "@/helpers/livro.js"
  import ModalCertidaoEletronica from "@/components/SofiaRei/Resumo/Impressao/Tipos/Certidao/ModalCertidaoEletronica"
  // services
  import InteiroTeorService from '@/services/InteiroTeorService.js'
  import ProtocolosService from "@/services/Protocolos"

  //components
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"

  import CertidaoService from "@/services/Files/CertidaoService.js"

  export default {
    name: 'InteiroTeor',
    components: {
      SubHeaderGrey,
      ModalCertidaoEletronica
    },
    props: {
      propDataPessoas: {type: Object, required: false},
      propTipoRegistro: { type: String, required: true },
      propRegistroId: {type: Number, required: true},
      propTipoRegistroExtenso: {type: String, required: true},
      propImpressao: { type: Object, required: true },
      propAssinantes: { type: Array, required: true },
      propAverbacoes: { type: Array, default: () => ([])},
      propRegistro: { type: Object, default: null },
      propInteiroTeor: { type: Object, default: () => ({})}
    },
    data () {
      return {
        modelos: [],
        modeloSelected: null,
        modeloImpressao: null,
        textoImpressao: null,
        tipos: {
          'N': 'NASCIMENTO',
          'O': 'OBITO',
          'C': 'CASAMENTO',
          'CR': 'CASAMENTO'
        },
        impressao: {},
        urlPDFCertidao: null,
        certidaoEletronicaId: null
      }
    },
    watch: {
      
      'impressao.procedimento' () {
        this.mesclarTexto()
      },
      propInteiroTeor () {
        this.mesclarTexto()
      },
      propImpressao () {
        if (this.propImpressao.procedimento) this.mesclarTexto()
      },
         
    },
    mounted () {
      // this.getModelos(true)

      this.localData = {...this.data}
      this.assinantes = [ ...this.propAssinantes ]

      if (this.propDataPessoas) this.impressao.pessoas = this.propDataPessoas


      this.impressao = { ...this.propImpressao }

      if (this.propImpressao.procedimento) this.mesclarTexto()
    },
    methods: {
      async getModelos (showLoader) {
        try {
          loader({ative: showLoader, text: 'Buscando modelos...'})

          const params = {
            tipo_registro: this.tipos[this.propTipoRegistro]
          }

          const res = await InteiroTeorService.getList(params)

          if (res) {
            this.modelos = res
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro ao buscar modelos de inteiro teor!', message.message)
        } finally {
          loader({ative: false, text: ''})
        }
      },
      changeText () {
        const modelo = { ...this.modeloSelected }

        this.modeloImpressao = { ...modelo }

        this.textoImpressao = modelo.descricao
      },
      verifyText () {
        return false

        if (this.modeloImpressao && this.modeloImpressao.descricao !== this.textoImpressao) return true
      },
      async salvarModelo () {
        try {
          const inteiroTeor = {
            ativo: true,
            titulo: this.modeloSelected.titulo,
            tipo_registro: this.tipos[this.propTipoRegistro],
            descricao: this.textoImpressao
          }

          const res = await InteiroTeorService.cadastrarInteiroTeor(inteiroTeor)

          if (res) {
            this.$toast.success('Cadastrado com sucesso!', {
              position: 'top-right',
              duration: 5000
            })

            // this.getModelos(false)
          }
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', message.message)
        }
      },
      async visualizar () {
        const valid = await this.$validator.validateAll()

        let textoUm = null
        let textoDois = null 

        const limit = 2350

        const arrText = this.textoImpressao.split('')

        const lastIndex = arrText.slice(0, limit).lastIndexOf(' ')

        textoUm = arrText.length > limit ? arrText.slice(0, lastIndex).join('') : this.textoImpressao
        textoDois = arrText.length >= limit ? arrText.slice(lastIndex, arrText.length).join('') : this.textoImpressao.substring(limit, this.impressao.length)

        // Tratando Tag
        textoUm = textoUm.replaceAll('spanclass', 'span class')
        textoDois = textoDois.replaceAll('spanclass', 'span class')

        if (valid) this.$emit('visualizar', {textoUm, textoDois})
      },
      async imprimir () {
        const valid = await this.$validator.validateAll()

        let textoUm = null
        let textoDois = null 

        const limit = 2350

        const arrText = this.textoImpressao.split('')

        const lastIndex = arrText.slice(0, limit).lastIndexOf(' ')

        textoUm = arrText.length > limit ? arrText.slice(0, lastIndex).join('') : this.textoImpressao
        textoDois = arrText.length >= limit ? arrText.slice(lastIndex, arrText.length).join('') : this.textoImpressao.substring(limit, this.impressao.length)

        // Tratando Tag
        textoUm = textoUm.replaceAll('spanclass', 'span class')
        textoDois = textoDois.replaceAll('spanclass', 'span class')

        if (valid) this.$emit('imprimir', {textoUm, textoDois})
      },
      changeImpressao () {
        this.$emit('changeImpressao', this.impressao)
      },
      voltar () {
        this.$emit('voltar')
      },
      getHtml (campo) {
        const html = document.querySelector('#' + campo).innerHTML
        this.textoImpressao = html
      },
      async mesclarTexto () {
        const { procedimento: {nome_requerente, protocolo_id, ordemServico, texto_procedimento } } = this.propImpressao
        const { livro: lv, folha, lado, termo } = this.propRegistro

        const { tipoSequencia } = livro.getTipoSequencia(lv.tipo_livro)

        let text = ''

        text += `CERTIFICO E DOU FÉ que, por requerimento de <b>${nome_requerente}</b>`
        text +=  protocolo_id ? `, protocolado sob o <b>nº ${await this.getProtocolo(protocolo_id)}</b>` : ''
        text += `, que, revendo o livro <b>${tipoSequencia}-${lv.num_livro}</b>, às <b>fls. ${folha}${ lado ? '-' + lado[0] : ''}</b>`
        text +=  termo ? ` , sob o número de <b>ordem ${termo}</b>` : ''
        text += `, verificou constar o assento de <b>${this.getTipoAssento(this.propTipoRegistro)}</b>, de teor seguinte: `
        text +=  texto_procedimento ? `<spanclass="text-break">"${texto_procedimento}."</span>` : ''
        text +=  this.propAverbacoes && this.propAverbacoes.length ? ` Consta ainda no campo das averbações e/ou anotações:` : ''
        text += this.propAverbacoes && this.propAverbacoes.length ? `<spanclass="text-break">${this.propAverbacoes.map(averb => averb.texto_averbacao.trim()).join('. ')}</span>` : ''
        text += `. Nada mais constando no referido assento. Eu _________________________________ oficial do Registro Civil, subscrevi, dou fé e assino.`

        // OBS: Deixamos 'spanclass' junto e separamos posteriormente para evitar a quebra da tag no tratamento de texto 

        this.textoImpressao = text
      },
      getTipoAssento (tipo) {
        if (tipo === 'N') {
          return 'NASCIMENTO'
        } else if (tipo === 'O') {
          return 'ÓBITO'
        } else {
          return 'CASAMENTO'
        }
      },
      async getProtocolo (id) {
        try {
          const protocolo = await ProtocolosService.show(id)

          return `${protocolo.numero}/${protocolo.ano}`
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)

          return 'Não informado'
        }
      },
      async gerarCertidao (impressao) {        
        try {
          loader({text: "Gerando Certidão Eletrônica...", active: true})
          impressao.tipo_registro = this.propTipoRegistroExtenso
          impressao.pessoas = this.propDataPessoas

          
          const res = await CertidaoService.gerarCertidaoEletronica(impressao, 'inteiro-teor')
          let blob = base64toBlob(res.data.responseBase64, 'application/pdf')
          let url = window.URL.createObjectURL(blob)
          
          this.urlPDFCertidao = url
          this.certidaoEletronicaId = res.data.certidaoId


          this.$bvModal.show('modal-impressao-certidao-eletronica')
          //window.open(url)
        } catch (error) {
          console.log('Error', error)
          const message = getErrors(error)
          //displayMessage('error', 'Erro ao gerar Certidão Eletrônica.', message.message)
          displayMessage('error', 'Erro ao gerar Certidão Eletrônica.', 'Tente novamente mais tarde.')
        } finally {
          loader({ active: false })   
        }
      },

      async assinarCertidaoEletronica (certidaoId) {
        try {
          this.$bvModal.hide('modal-impressao-certidao-eletronica')
          loader({text: "Assinando Certidão Eletrônica...", active: true})
          const res = await CertidaoService.assinarCertidaoEletronica(this.propTipoRegistroExtenso, certidaoId, this.propRegistroId)


          return displayMessage('success', 'Certidão eletrônica assinada com sucesso!').then(() => {
            this.localData.documentoCertidaoEletronicaInteiroTeor = res.data
            window.open(res.data.link_assinatura) 
            //this.reload()
          })
        } catch (error) {
          console.log('Error', error)
          const message = getErrors(error)
          //displayMessage('error', 'Erro ao assinar Certidão Eletrônica.', message.message)
          displayMessage('error', 'Erro ao assinar Certidão Eletrônica.', 'Tente novamente mais tarde.')
        } finally {
          loader({ active: false })   
        }
      },

      async visualizarCertidao (certidao) {
        return window.open(certidao.link_assinatura)
      }
       
    }
  }
</script>

<style lang="scss">
  .editorTextoInteiroTeor {
    width: 100%;
    min-height: 500px;
    border: 1px solid #CCC;
    padding: 10px;
    border-radius: 3px;
    background-color: #FFFFFF;
  }

</style>
